import { Stack, type SxProps, type Theme } from '@mui/material';

import { useScrollable } from './useScrollable';

export const ScrollableHeader = ({
  children,
  hideBorderWhenOnTop,
  className,
  sx,
}: React.PropsWithChildren<{
  hideBorderWhenOnTop?: boolean;
  className?: string;
  sx?: SxProps<Theme>;
}>) => {
  const { isScrolledVertically } = useScrollable();

  return (
    <Stack
      className={className}
      sx={[
        {
          borderBottom: hideBorderWhenOnTop
            ? 'none'
            : '1px solid var(--mui-palette-divider)',
          boxShadow: isScrolledVertically
            ? 'var(--mui-customShadows-panel)'
            : undefined,
          transition: 'box-shadow 200ms ease',
        },
        ...(Array.isArray(sx) ? sx : [sx ?? false]),
      ]}
    >
      {children}
    </Stack>
  );
};
